import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Zap } from "lucide-react";
import { SectionHeader, AUTO_INPUT_CLS, PRIORITY_LABEL, fmtSla } from "@/components/newTicket/parts";

export default function PriorityStatusSection({ autoFields }) {
  return (
    <section data-testid="section-priority-status">
      <SectionHeader
        letter="D" title="Priority & Status" icon={Zap}
        subtitle="Auto-set · Read-only"
      />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        <div>
          <Label className="text-xs font-semibold text-slate-700">Priority <span className="text-slate-400 font-normal">(auto)</span></Label>
          <Input
            readOnly
            data-testid="priority-auto"
            className={`mt-1.5 h-10 ${AUTO_INPUT_CLS} font-medium`}
            value={autoFields.priority ? PRIORITY_LABEL[autoFields.priority] : ""}
            placeholder="auto"
          />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">Status <span className="text-slate-400 font-normal">(auto)</span></Label>
          <Input
            readOnly
            data-testid="status-auto"
            className="mt-1.5 h-10 bg-blue-50 border-blue-200 text-blue-900 cursor-not-allowed font-semibold"
            value="In Process"
          />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">TAT Starts</Label>
          <Input
            readOnly
            data-testid="tat-starts-auto"
            className={`mt-1.5 h-10 ${AUTO_INPUT_CLS}`}
            value="On creation (working hours)"
          />
        </div>
        <div>
          <Label className="text-xs font-semibold text-slate-700">SLA / TAT <span className="text-slate-400 font-normal">(auto)</span></Label>
          <Input
            readOnly
            data-testid="sla-auto"
            className="mt-1.5 h-10 bg-amber-50 border-amber-200 text-amber-900 cursor-not-allowed font-semibold"
            value={autoFields.sla_minutes ? fmtSla(autoFields.sla_minutes) : ""}
            placeholder="-- auto --"
          />
        </div>
      </div>
      <p className="text-[11px] text-slate-500 mt-2.5">
        TAT: auto from Issue Type
      </p>
    </section>
  );
}
